module.exports = __webpack_public_path__ + "fef1ec61c0f7dcd989f3a32ec0ae9295.png";